__turbopack_context__.v({
  "avatarImg": "ProductRoadmapPage-module-scss-module__LtouoG__avatarImg",
  "breadcrumbsBand": "ProductRoadmapPage-module-scss-module__LtouoG__breadcrumbsBand",
  "byline": "ProductRoadmapPage-module-scss-module__LtouoG__byline",
  "bylineStrong": "ProductRoadmapPage-module-scss-module__LtouoG__bylineStrong",
  "contentColumn": "ProductRoadmapPage-module-scss-module__LtouoG__contentColumn",
  "hero": "ProductRoadmapPage-module-scss-module__LtouoG__hero",
  "heroCard": "ProductRoadmapPage-module-scss-module__LtouoG__heroCard",
  "heroCopy": "ProductRoadmapPage-module-scss-module__LtouoG__heroCopy",
  "heroDek": "ProductRoadmapPage-module-scss-module__LtouoG__heroDek",
  "heroImage": "ProductRoadmapPage-module-scss-module__LtouoG__heroImage",
  "heroImageWrap": "ProductRoadmapPage-module-scss-module__LtouoG__heroImageWrap",
  "heroOuter": "ProductRoadmapPage-module-scss-module__LtouoG__heroOuter",
  "heroTitle": "ProductRoadmapPage-module-scss-module__LtouoG__heroTitle",
  "introModule": "ProductRoadmapPage-module-scss-module__LtouoG__introModule",
  "introRow": "ProductRoadmapPage-module-scss-module__LtouoG__introRow",
  "main": "ProductRoadmapPage-module-scss-module__LtouoG__main",
  "page": "ProductRoadmapPage-module-scss-module__LtouoG__page",
  "richText": "ProductRoadmapPage-module-scss-module__LtouoG__richText",
  "roadmapEmphasis": "ProductRoadmapPage-module-scss-module__LtouoG__roadmapEmphasis",
  "sectionImage": "ProductRoadmapPage-module-scss-module__LtouoG__sectionImage",
  "sectionImageFrame": "ProductRoadmapPage-module-scss-module__LtouoG__sectionImageFrame",
  "sectionImageWrap": "ProductRoadmapPage-module-scss-module__LtouoG__sectionImageWrap",
  "sectionModule": "ProductRoadmapPage-module-scss-module__LtouoG__sectionModule",
  "sectionTitle": "ProductRoadmapPage-module-scss-module__LtouoG__sectionTitle",
  "sectionVideo": "ProductRoadmapPage-module-scss-module__LtouoG__sectionVideo",
  "shell": "ProductRoadmapPage-module-scss-module__LtouoG__shell",
  "visualPlaceholder": "ProductRoadmapPage-module-scss-module__LtouoG__visualPlaceholder",
});
